import { useAtomValue } from 'jotai'
import React from 'react'
import { match } from 'ts-pattern'

import { dialogInfoAtom } from '../atoms'

import { CloneCustomerAttributeDialog } from './CloneCustomerAttributeDialog'
import { CreateInBulkSelectCustomerAttributesDialog } from './CreateInBulkSelectCustomerAttributesDialog'
import { CreateInBulkSelectFiltersDialog } from './CreateInBulkSelectFiltersDialog'
import { CreateInBulkSelectFiltersDialog as CreateInBulkSelectFiltersDialog2 } from './CreateInBulkSelectFiltersDialog2'
import { CreateInBulkSelectFiltersDialog as CreateInBulkSelectFiltersDialog3 } from './CreateInBulkSelectFiltersDialog3'
import { DeleteCustomerAttributeDialog } from './DeleteCustomerAttributeDialog'
import { DeleteInBulkSelectCustomerAttributesDialog } from './DeleteInBulkSelectCustomerAttributesDialog'
import { EditCustomerAttributeDialog } from './EditCustomerAttributeDialog'
import { MoveToGroupDialog } from './MoveToGroupDialog'
import { SortCustomerAttributeDialog } from './SortCustomerAttributeDialog'

export const Dialogs = () => {
  const dialogInfo = useAtomValue(dialogInfoAtom)

  return match(dialogInfo?.dialogType)
    .with(undefined, () => null)
    .with('create', 'update', () => <EditCustomerAttributeDialog />)
    .with('createInBulkSelectFilters', () => (
      <CreateInBulkSelectFiltersDialog />
    ))
    .with('createInBulkSelectFilters2', () => (
      <CreateInBulkSelectFiltersDialog2 />
    ))
    .with('createInBulkSelectFilters3', () => (
      <CreateInBulkSelectFiltersDialog3 />
    ))
    .with('createInBulkSelectCustomerAttributes', () => (
      <CreateInBulkSelectCustomerAttributesDialog />
    ))
    .with('delete', () => <DeleteCustomerAttributeDialog />)
    .with('deleteInBulkSelectCustomerAttributes', () => (
      <DeleteInBulkSelectCustomerAttributesDialog />
    ))
    .with('clone', () => <CloneCustomerAttributeDialog />)
    .with('moveToGroup', () => <MoveToGroupDialog />)
    .with('sort', () => <SortCustomerAttributeDialog />)
    .exhaustive()
}
